import type { ReactNode } from "react";

import { unstable_cache } from "next/cache";
import { notFound } from "next/navigation";

import NavigationBar from "~/lib/components/navigation-bar";
import { getMenu } from "~/lib/utils/cms";

export const getMenuData = unstable_cache(
	async () => {
		return (await getMenu())?.data;
	},
	["Menu", "All"],
	{ revalidate: 86400, tags: ["Menu", "All"] },
);

export default async function OnboardingLayout({
	children,
}: Readonly<{
	children: ReactNode;
}>) {
	const data = await getMenuData();
	if (!data) return notFound();
	return (
		<>
			<NavigationBar className="!text-white" menuData={data} />
			{children}
		</>
	);
}
